import React from 'react';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import AppsContainer from '@tenant/core/AppsContainer';
import { ROUTE_STRING } from 'constants/RouteString';
import PipelineWizard from './components/Wizard/PipelineWizard';

// Setup wizard page (OQ-2 create-only). Registered at ROUTE_STRING.PIPELINE.ADD, gated
// on PIPELINE_CREATE (see ./index.js).
const AddPipeline = () => (
  <AppsContainer
    fullView
    title={
      <Breadcrumbs aria-label='breadcrumb'>
        <Typography color='text.primary'>Deployment</Typography>
        <Typography color='text.primary'>
          <Link to={ROUTE_STRING.PIPELINE.LIST}>Pipelines</Link>
        </Typography>
        <Typography color='text.primary'>Create</Typography>
      </Breadcrumbs>
    }
  >
    <Box>
      <PipelineWizard />
    </Box>
  </AppsContainer>
);

export default React.memo(AddPipeline);
